import { FormField } from "@babackapp/ui/components/form";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import FormOptionsSelector from "@babackapp/react-hook-forms-components/form-option-selector";
import FormPasswordInput from "@babackapp/react-hook-forms-components/form-password-input";
import useTranslation from "@babackapp/translations/use-translation";
import { useFormContext } from "react-hook-form";
import { ShopImportFormValues } from "./import-settings-form-types";

export default function ImportServerForm() {
  const { control } = useFormContext<ShopImportFormValues>();
  const t = useTranslation();

  return (
    <div className="flex flex-col gap-8">
      <FormField
        control={control}
        name="server.type"
        render={({ field }) => (
          <FormOptionsSelector
            label={t("settings.integrations.imports.addImport.serverType")}
            options={serverTypeOptions}
            {...field}
          />
        )}
      />

      <FormInputRow>
        <FormField
          control={control}
          name="server.login.host"
          render={({ field }) => (
            <FormInput
              label={t("settings.integrations.imports.addImport.host")}
              placeholder="ftp.example.com"
              {...field}
            />
          )}
        />

        <FormField
          control={control}
          name="server.login.port"
          render={({ field }) => (
            <FormInput
              label="Port"
              placeholder="22"
              type="number"
              {...field}
              value={field.value ?? ""}
              onChange={(e) => {
                const val = e.target.value;
                field.onChange(val === "" ? null : Number(val));
              }}
            />
          )}
        />
      </FormInputRow>

      <FormInputRow>
        <FormField
          control={control}
          name="server.login.user"
          render={({ field }) => (
            <FormInput
              label={t("settings.integrations.imports.addImport.user")}
              placeholder="myftpuser"
              {...field}
            />
          )}
        />

        <FormField
          control={control}
          name="server.login.password"
          render={({ field }) => (
            <FormPasswordInput
              label={t("settings.integrations.imports.addImport.password")}
              placeholder="*********"
              {...field}
            />
          )}
        />
      </FormInputRow>

      <FormField
        control={control}
        name="server.login.path"
        render={({ field }) => (
          <FormInput
            label={t("settings.integrations.imports.addImport.path.title")}
            placeholder="./OUT/Baback"
            {...field}
          />
        )}
      />
    </div>
  );
}

const serverTypeOptions = [
  { key: "ftp", label: "FTP" },
  { key: "sftp", label: "SFTP" },
];
